import React from 'react';
import PropTypes from 'prop-types'
import PayrollStep from "../Atoms/PayrollStep";
import ProgressBar from "../Atoms/ProgressBar";

const PayrollSteps = (props) => {
  const {steps} = props

  // Valor de prueba. Se eliminará cuando ya sea dinámico
  const currentStep = 1
  return (
    <div className="s-relative s-cross-center nowrap">
      <ProgressBar
        className="s-absolute s-h-2px s-left-0 s-top-2px s-w-full"
        progress={currentStep}
        max={steps.length - 1}/>
      {steps.map((step, i) => (
        <PayrollStep isCurrent={i === currentStep}
          text={step}/>
      ))}
    </div>
  );
};

PayrollSteps.propTypes = {
  steps: PropTypes.array.isRequired,
}

export default PayrollSteps;
